import moment from 'moment';
import React from 'react'

export const TableRow = (props) => {
  const { user, id, gamePeriod, gameId, value, createdAt, printedAt, WorkTime, detail, images, order } = props;

  const _detail = JSON.parse(detail)

  const numberRows = _detail.numberRows.map(i => {
    return {
      numbers: i.numbers,
      playMethod: i.playMethod,
      value: i.value
    }
  })

  const l = ['A', 'B', 'C', 'D', 'E', 'F']

  return (
    <tr>
      <td>
        {(user && user.name) || ""}<br />
        <span><strong className={`text-primary`}>{(user && user.phone) || ""}</strong></span>
      </td>
      <td className='text-center'>
        STT: <b>{order}</b><br />
        <img alt='' src={require(`../../../../assets/img/logo-${gameId}.png`)} className="img-thumbnail" width={90} height={30}></img><br />
        {id}
      </td>
      <td className='text-center'>
        {gamePeriod.name}
      </td>
      <td className='text-center text-success'>{new Intl.NumberFormat('vn-VI', {}).format(value) || ""}</td>
      <td>
        Mua lúc: <b>{moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()}</b> <br />
        Hoàn thành lúc: <b>{moment(printedAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()}</b>
        <br />
        <br />
        {numberRows.map((ii, idx) => {
          if(gameId === 'lotto535') {
            if (ii.playMethod.includes('GROUP_NORMAL_')) {
              return (
                <>
                  {l[idx]} :
                  <b>{ii.numbers.split(' ').slice(0, ii.numbers.split(' ').length - 1).join(' ')}</b> | <b className='text-danger'>{ii.numbers.split(' ').slice(-1)}</b>
                  {idx < numberRows.length - 1 && <br />}
                </>
              )
            }
            const specialLength = ii.playMethod.split('GROUP_SPECIAL_')[1]
            return (
              <>
                {l[idx]} :
                <b>{ii.numbers.split(' ').slice(0, 5).join(' ')}</b> | <b className='text-danger'>{ii.numbers.split(' ').slice(-specialLength).join(' ')}</b>
                {idx < numberRows.length - 1 && <br />}
              </>
            )
          }
          let method = ''
          if (ii.playMethod === 'LOWER') {
            method = 'Nhỏ'
          } else if (ii.playMethod === 'UPPER') {
            method = 'Lớn'
          } else if (ii.playMethod === 'DRAW_UPPER_LOWER') {
            method = 'Hòa Lớn Nhỏ'
          } else if (ii.playMethod === 'EVEN') {
            method = 'Chẵn'
          } else if (ii.playMethod === 'ODD') {
            method = 'Lẻ'
          } else if (ii.playMethod === 'EVEN_1112') {
            method = 'Chẵn 11 - 12'
          } else if (ii.playMethod === 'ODD_1112') {
            method = 'Lẻ 11 - 12'
          } else if (ii.playMethod === 'DRAW_ODD_EVEN') {
            method = 'Hòa Chẵn Lẻ'
          }
          return (
            <>
              {l[idx]} :
              {ii.numbers.length === 0 && method} <b>{ii.numbers}</b>
              {idx < numberRows.length - 1 && <br />}
            </>
          )
        })}
      </td>
      <td className='text-center'>
        <img alt='' src={images[0] ? images[0] : ''} className="img-thumbnail" width={250}></img>
      </td>
    </tr>
  );
};